import axios from 'axios'
import AbstractAxiosMock from './AbstractAxiosMock'
import { config } from '@/config'

export default class DieciContaoServiceMock extends AbstractAxiosMock {

  async 'POST /api/vouchers/buy' (method, url, { vouchers, firstname, lastname, company, street, postcode, city, phoneNumber, email, message, checkAgb }) {
    const response = {
			status: true,
			error: '',
			sign: '',
			ref: Date.now(),
			data: {
				vouchers, firstname, lastname, company, street, postcode, city, phoneNumber, email, message, checkAgb
			}
		};

		if (email.includes('fail')) {
			response.status = false;
			response.error = 'Bitte alle Felder korrekt ausfüllen!'
		}

    return this.fakeRequest({status: true, response}, 200, 500);
	}
	
	async 'POST /api/vouchers/balance' (method, url, { cardNumber }) {
    const response = {
			status: true,
			error: '',
			balance: 21540, // in cents
			data: {
				cardNumber
			}
		};
    return this.fakeRequest({status: true, response}, 200, 500);
	}
	
	async 'POST /api/vouchers/reload' (method, url, { cardNumber, cvc, value }) {
    const response = {
			status: true,
			error: '',
			sign: '',
			ref: Date.now(),
			data: {
				cardNumber, cvc, value
			}
		};
    return this.fakeRequest({status: true, response}, 200, 500);
  }
}
